/**
 * SIM-18 / ACS-4355 — screen enum for the /reset-password full-page state
 * machine. Referenced by the root `pages/Auth/ResetPassword.f.jsx` and each
 * `screens/*.f.jsx` module. Single source of truth so a rename lands in one
 * place. The 7th entry (`PASSKEY_CREATION_FROM_EMAIL`) is the mounting screen
 * for the passkey-from-email link (Scenario 11); post-bind success is still
 * `RESET_SUCCESS` with an `isPasskeyCreated` variant flag on shared state.
 */
export const SCREENS = {
    PASSKEY_FIRST_LANDING: 'PASSKEY_FIRST_LANDING',
    TRADITIONAL_RESET: 'TRADITIONAL_RESET',
    EMAIL_SENT: 'EMAIL_SENT',
    SET_NEW_PASSWORD: 'SET_NEW_PASSWORD',
    RESET_SUCCESS: 'RESET_SUCCESS',
    TOKEN_ERROR: 'TOKEN_ERROR',
    PASSKEY_CREATION_FROM_EMAIL: 'PASSKEY_CREATION_FROM_EMAIL'
};

// Error codes surfaced across screens. Kept alongside SCREENS so screens do not
// each redefine the same constants (SIM-1 defined POS/EMAIL_SEND_FAILED_CODE on
// the SIM-1 page root; SIM-18 promotes them here plus the passkey max-attempts
// code so PasskeyFirstLanding and EmailSentConfirmation share ONE definition).
export const ERROR_CODES = {
    POS_ACCOUNT_ERROR: 'ERR_400004',
    // SIM-1 placeholder pending backend confirmation of the exact code string.
    // Update in one place once backend publishes it.
    EMAIL_SEND_FAILED_CODE: 'ERR_RESET_EMAIL_SEND_FAILED',
    ERR_PK_MAX_ATTEMPTS: 'ERR_PK_MAX_ATTEMPTS'
};
